<template>
  <div class="nx-flex-center-between nx-padding-lr nx-box-sizing download-head-wrap">
    <div class="nx-flex-align-center">
      <van-image
        class="logo"
        width="42"
        heihgt="42"
        src="https://cdn-zone.app-prod.bjev.com.cn/logo-new.png?x-oss-process=image/resize,w_500/quality,q_90"
      />
      <span class="title">北京汽车</span>
    </div>
    <nx-guide
      :visible.sync="show"
    />
    <van-button class="btn" color="#6A8BC9" type="primary" @click="downloadAPP">立即下载</van-button>
  </div>
</template>

<script>
import { Toast } from 'vant';
import {
  isJudgeDevice,
  isWeChatBrowser,
} from '@/utils/is';
export default {
  name: 'NxHeadDownload',
  data() {
    return {
      show: false,
    };
  },
  created() {
  },
  methods: {
    downloadAPP() {
      // 判断用户是否在微信打开
      if (isWeChatBrowser()) {
        this.show = true;
        return;
      }

      // 判断当前环境是否在安卓或ios
      if (!isJudgeDevice() === 'IOS' && !isJudgeDevice() === 'Android') {
        return Toast({
          message: '暂不支持该机型',
          forbidClick: true,
        });
      }

      if (isJudgeDevice() === 'IOS') {
        window.location = 'https://apps.apple.com/cn/app/id1449952332';
      }

      if (isJudgeDevice() === 'Android') {
        window.location = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.dj.xny';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.download-head-wrap{
  width: 100%;
  height: 56px;
  position: fixed;
  top: 0;
  left: 0;

  z-index: 1;
  background: #fff;
  box-shadow: 0px 2px 8px 0px rgba(0,0,0,.1);
  .title{
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    line-height: 22px;
    margin-left: 12px;
  }
  .btn{
    width: 88px;
    height: 30px;
    border-radius: 15px;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    padding: 0;
  }
}

</style>
